import { useNavigate } from 'react-router-dom';

const Unauthorized401 = () => {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col gap-4 h-full w-full justify-center items-center bg-brand-background">
            <div className="flex gap-3">
                <div className="text-brand-neutral-400 text-4xl">401</div>
                <div className="text-brand-text text-4xl font-bold">Unauthorized</div>
            </div>
            <div className="text-brand-neutral-300 text-lg">You don{`'`}t have permission to access this page.</div>
            <div
                className="bg-brand-red hover:bg-brand-red-light cursor-pointer rounded-md p-2 px-4 text-brand-text mt-4"
                onClick={() => navigate('/portal')}>
                Go to home page
            </div>
            <div className="text-brand-red-light mt-6">Kindly reach out to support if you need any help.</div>
        </div>
    );
};
export default Unauthorized401;
